// Configuration AWS — valeurs injectées par Terraform outputs
// Copier aws-config.example.js → aws-config.js et remplir après `terraform output`

const config = {
  appsync: {
    url: process.env.REACT_APP_APPSYNC_URL || "",
    apiKey: process.env.REACT_APP_APPSYNC_API_KEY || "",
    region: process.env.REACT_APP_AWS_REGION || "eu-west-3",
  },
  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
    clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
  },
};

export default config;
